import BodyText from 'LuxKit/Typography/BodyText'
import useExperiencePlace from 'hooks/Experiences/useExperiencePlace'
import useExperienceSearch from 'hooks/Experiences/useExperienceSearch'
import React from 'react'
import { useIntl } from 'react-intl'
import ExperienceListTileCarousel from './ExperienceListTileCarousel'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import { getListName } from 'analytics/enhanced-ecommerce'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'

interface Props {
  experience: App.ExperienceOffer
  pageSize?: number
  gutterSize?: number
}

function ExperienceYAMLList(props: Props) {
  const { experience, pageSize, gutterSize } = props
  const intl = useIntl()

  const place = useExperiencePlace(experience)
  const categoryCodes = experience.primaryCategory?.parentId ?? experience.primaryCategory?.id
  const [list, experiences] = useExperienceSearch({
    placeId: place?.id,
    randomize: true,
    excludeIds: [experience.id],
  }, {
    categoryCodes: categoryCodes ? [categoryCodes] : undefined,
  })

  const tracking = useOfferListTracking(
    getListName('OfferList', 'EXPERIENCES', 'YAML Carousel'),
    { key: experience.id },
  )

  const fetching = list.fetching && !list.error

  return <div>
    {list.error && <BodyText variant="large">{intl.formatMessage({
      id: '8orlxzGmuk',
      defaultMessage: 'Something went wrong!',
      description: 'Error message when experience YAML list fails to load',
    })}
    </BodyText>}
    {!fetching && !list.error && list.ids.length === 0 && <BodyText variant="large">
      {intl.formatMessage({
        id: '3XP97ylZxp',
        defaultMessage: 'No experiences available',
        description: 'Empty state message when no experiences found in YAML list',
      })}
    </BodyText>}
    <OfferListEventsProvider tracking={tracking}>
      <ExperienceListTileCarousel
        experiences={experiences}
        listFetching={fetching}
        pageSize={pageSize}
        gutterSize={gutterSize}
      />
    </OfferListEventsProvider>
  </div>
}

export default React.memo(ExperienceYAMLList)
